
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/inicio",
      function () {
        return require("private-next-pages/inicio.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/inicio"])
      });
    }
  